// @ts-check
import React, { Component } from 'react';
import { Row, Widget } from 'shared/containers/portal_layout';
import { reduxForm, Field } from 'utils/reduxFormWrapper';
import { filter } from 'lodash';
import HForm from 'shared/containers/portal_layout/HForm';
import FlashMessageActions from 'shared/actions/FlashMessageActions';
import Errors from 'shared/components/Errors';
import LoadingContent from 'shared/components/LoadingContent';
import SpinnerButton from 'shared/components/SpinnerButton';
import api from 'utils/api';
import { decamelizeKeys } from 'humps';
import styles from './Edit.module.scss';

class NotificationPreferences extends Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      checkedPreferences: null,
      preferences: null,
      entityName: '',
    };
    this.savePreferences = this.savePreferences.bind(this);
  }

  componentDidMount() {
    api
      .get(
        `${this.props.apiPrefix}/entities/${this.props.entityId}/notification_preferences/edit`
      )
      .then((response) => {
        this.setState({
          checkedPreferences: response.data.checkedPreferences,
          preferences: response.data.preferences,
          entityName: response.data.entityName,
        });
      });
  }

  savePreferences(formValues) {
    return api
      .put(
        `${this.props.apiPrefix}/entities/${this.props.entityId}/notification_preferences`,
        decamelizeKeys(formValues)
      )
      .then((response) => {
        FlashMessageActions.flashSuccess({ message: 'Preferences Saved!' });
      });
  }

  render() {
    return (
      <FormifiedPresentationComponent
        entityName={this.state.entityName}
        form="notificationPreferences"
        onSubmit={this.savePreferences}
        initialValues={
          this.state.checkedPreferences
            ? { checkedPreferences: this.state.checkedPreferences }
            : null
        }
        {...this.state}
      />
    );
  }
}

const PresentationComponent = (props) => {
  if (!props.checkedPreferences) return <LoadingContent />;
  return (
    <div>
      <Row>
        <Widget title="Notification Preferences" span={12} nopadding>
          <HForm onSubmit={props.handleSubmit}>
            <Errors errors={props.error || []} />
            <Field name="checkedPreferences" component={Preferences} />
            <br />

            <div className="form-actions">
              <SpinnerButton
                type="submit"
                className="btn btn-primary"
                loading={props.submitting}
              >
                Save Preferences
              </SpinnerButton>
            </div>
          </HForm>
        </Widget>
      </Row>
    </div>
  );
};

const FormifiedPresentationComponent = reduxForm({})(PresentationComponent);

const Preferences = (props) => {
  const {
    input: { value: values, onChange },
  } = props;

  const isChecked = (val) => values.includes(val);
  const toggleCheckedValue = (val) => () => {
    if (!isChecked(val)) {
      onChange(values.concat([val]));
    }
    if (isChecked(val)) {
      onChange(filter(values, (v) => v !== val));
    }
  };

  return (
    <div style={{ padding: '0 1rem' }}>
      <h4>Staff and Provider Notifications</h4>
      <table className={styles.preferencesTable}>
        <thead>
          <tr>
            <th>Event {'&'} Notification Type</th>
            <th>Notify Staff</th>
            <th>Notify Provider</th>
          </tr>
        </thead>

        <tbody>
          <tr>
            <td>
              Email when a new referral is received from another practice on
              AristaMD
            </td>
            <td>
              <input
                type="checkbox"
                onChange={toggleCheckedValue('staff_new_referral_received')}
                checked={isChecked('staff_new_referral_received')}
              />
            </td>
            <td>
              <input
                type="checkbox"
                onChange={toggleCheckedValue('provider_new_referral_received')}
                checked={isChecked('provider_new_referral_received')}
              />
            </td>
          </tr>
          <tr>
            <td>
              Email when a new referral is received from a AristaMD Powered Form
            </td>
            <td>
              <input
                type="checkbox"
                onChange={toggleCheckedValue('staff_new_ppf_referral_email')}
                checked={isChecked('staff_new_ppf_referral_email')}
              />
            </td>
            <td>
              <input
                type="checkbox"
                onChange={toggleCheckedValue(
                  'provider_new_ppf_referral_received'
                )}
                checked={isChecked('provider_new_ppf_referral_received')}
              />
            </td>
          </tr>
          <tr>
            <td>Email when a new referral is entered manually as inbound</td>
            <td>
              <input
                type="checkbox"
                onChange={toggleCheckedValue(
                  'staff_new_inbound_entered_referral_email'
                )}
                checked={isChecked('staff_new_inbound_entered_referral_email')}
              />
            </td>
            <td>
              <input
                type="checkbox"
                onChange={toggleCheckedValue(
                  'provider_new_inbound_entered_referral'
                )}
                checked={isChecked('provider_new_inbound_entered_referral')}
              />
            </td>
          </tr>
          <tr>
            <td>Email when a referral is withdrawn</td>
            <td>
              <input
                type="checkbox"
                onChange={toggleCheckedValue('staff_referral_withdrawn')}
                checked={isChecked('staff_referral_withdrawn')}
              />
            </td>
            <td>
              <input
                type="checkbox"
                onChange={toggleCheckedValue('provider_referral_withdrawn')}
                checked={isChecked('provider_referral_withdrawn')}
              />
            </td>
          </tr>

          <tr>
            <td>Email when a sent referral is scheduled</td>
            <td>
              <input
                type="checkbox"
                onChange={toggleCheckedValue('staff_sent_referral_scheduled')}
                checked={isChecked('staff_sent_referral_scheduled')}
              />
            </td>
            <td>
              <input
                type="checkbox"
                onChange={toggleCheckedValue(
                  'provider_sent_referral_scheduled'
                )}
                checked={isChecked('provider_sent_referral_scheduled')}
              />
            </td>
          </tr>

          <tr>
            <td>Email when a sent referral is rejected</td>
            <td>
              <input
                type="checkbox"
                onChange={toggleCheckedValue('staff_sent_referral_rejected')}
                checked={isChecked('staff_sent_referral_rejected')}
                name="Notify staff when a sent referral is rejected"
              />
            </td>
            <td>
              <input
                type="checkbox"
                onChange={toggleCheckedValue('provider_sent_referral_rejected')}
                checked={isChecked('provider_sent_referral_rejected')}
              />
            </td>
          </tr>
          <tr>
            <td>Email when a sent referral is marked as exhausted</td>
            <td>
              <input
                type="checkbox"
                onChange={toggleCheckedValue('staff_sent_referral_exhausted')}
                checked={isChecked('staff_sent_referral_exhausted')}
                name="Notify staff when a sent referral is exhausted"
              />
            </td>
            <td>
              <input
                type="checkbox"
                onChange={toggleCheckedValue(
                  'provider_sent_referral_exhausted'
                )}
                checked={isChecked('provider_sent_referral_exhausted')}
              />
            </td>
          </tr>
          <tr>
            <td>
              Email when new files are uploaded to a AristaMD Powered Form
              referral
            </td>
            <td>
              <input
                type="checkbox"
                onChange={toggleCheckedValue('new_files_on_ppf_email')}
                checked={isChecked('new_files_on_ppf_email')}
                name={`Email Notification when new files are uploaded to a "PPF" Referral`}
              />
            </td>
            <td />
          </tr>
          <tr>
            <td>
              Email when new files are uploaded to a received (platform)
              referral
            </td>
            <td>
              <input
                type="checkbox"
                onChange={toggleCheckedValue(
                  'new_files_on_platform_referral_email'
                )}
                checked={isChecked('new_files_on_platform_referral_email')}
                name={`Email Notification when new files are uploaded to a received referral`}
              />
            </td>
            <td />
          </tr>
          <tr>
            <td>
              Email when new files are uploaded to an inbound-entered referral
            </td>
            <td>
              <input
                type="checkbox"
                onChange={toggleCheckedValue(
                  'new_files_on_inbound_referral_email'
                )}
                checked={isChecked('new_files_on_inbound_referral_email')}
                name={`Email Notification when new files are uploaded to an inbound referral`}
              />
            </td>
            <td />
          </tr>
        </tbody>
      </table>
      <br />

      <h4>Patient Notifications</h4>
      <table className={styles.preferencesTable}>
        <thead>
          <tr>
            <th>Event {'&'} Notification Type</th>
            <th>Mobile Text </th>
            <th>Email</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>Notify patient when appointment is scheduled or rescheduled</td>
            <td>
              <input
                type="checkbox"
                onChange={toggleCheckedValue('patient_appointment_scheduled')}
                checked={isChecked('patient_appointment_scheduled')}
              />
            </td>
            <td />
          </tr>

          <tr>
            <td>Send appointment reminders to patient</td>
            <td>
              <input
                type="checkbox"
                onChange={toggleCheckedValue(
                  'patient_appointment_text_reminder'
                )}
                checked={isChecked('patient_appointment_text_reminder')}
                name="Send text appointment reminders to patient"
              />
            </td>
            <td>
              <input
                type="checkbox"
                onChange={toggleCheckedValue(
                  'patient_appointment_email_reminder'
                )}
                checked={isChecked('patient_appointment_email_reminder')}
                name="Send email appointment reminders to patient"
              />
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  );
};

export default NotificationPreferences;
